import React from 'react';

const PageLoader = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white/60 backdrop-blur-md z-[9999]">
            <div className="flex flex-col items-center gap-6">
                {/* Animated Rings */}
                <div className="relative h-16 w-16">
                    <div className="absolute inset-0 border-4 border-blue-600/10 rounded-full" />
                    <div className="absolute inset-0 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                    {/* Inner pulsating dot */}
                    <div className="absolute inset-4 bg-blue-600 rounded-full animate-pulse opacity-20" />
                </div>

                {/* Loading Text */}
                <div className="flex flex-col items-center gap-1.5">
                    <span className="text-[13px] font-black text-slate-800 tracking-[0.2em]">
                        SynexOS
                    </span>
                    <span className="text-[11px] font-bold text-slate-400 tracking-widest animate-pulse">
                        Loading Experience...
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PageLoader;
